import {NetCostState} from "@/modules/net_cost/types";
import {ActionTree, Module} from "vuex";
import {RootState} from "@/store/types";
import {saveNetCost, getNetCosts, deleteNetCost, saveNetCosts} from "@/services/net_cost";

export const state: NetCostState = {
    net_cost: {
      id: "",
      item_code: "",
      id_item: 0,
      net_cost: "",
      processing_cost: "",
      material_cost: "",
      additional_cost: "",
      start_date: "",
      end_date: ""
    }
}

const actions: ActionTree<NetCostState, RootState> = {
    async SAVE_NET_COST(_, netCost) {
        await saveNetCost(netCost);
    },
    async GET_NET_COSTS(_, payload) {
      return await getNetCosts(payload);
    },
    async DELETE_NET_COST(_, id) {
      return await deleteNetCost(id);
    },
    async SAVE_NET_COSTS(_, netCosts) {
      await saveNetCosts(netCosts);
    }
}

export const net_cost: Module<NetCostState, RootState> = {
    state,
    actions,
}